// TSS vite/02 §"File-level constants" — every domain number of the
// Rapichontico simulation lives here.

export const DIGITS_PER_DRAW = 4;

// 0000–9999. The full inventory the store sells from.
export const TOTAL_NUMBERS = 10_000;

// Numbers already sold when a browser session starts (TSS demo requirement).
export const PRESOLD_COUNT = 5_500;

export const DRAW_INTERVAL_MS = 30 * 60_000;

export const HISTORY_SIZE = 10;

// COP. The demo has no backend, so these are the only price/prize source.
export const TICKET_PRICE = 5_000;
export const PRIZE_AMOUNT = 40_000_000;

// Prefix mixed into every seeded PRNG so the pre-sold inventory and the draw
// results never derive from the same stream for the same integer input.
export const SEED_SALT = {
    INVENTORY: 0x9e37,
    DRAW:      0x85eb,
};

export const PAYMENT_SIMULATION_MS = 1_800;

// Reveal choreography: the drum spins, then the balls lock left to right.
export const REVEAL_SCRAMBLE_MS = 70;
export const REVEAL_LEAD_MS = 1_100;
export const REVEAL_LOCK_STEP_MS = 620;

export const DRUM_BALL_COUNT = 18;

export const TICKET_STATUS = {
    PENDING: 'pending',
    WON:     'won',
    LOST:    'lost',
};
